import * as CertificateActions from './certificate.actions';
import {Certificate} from '../certificate.model';

export interface State {
  certificate: Certificate;
}

const initialState: State = {
  certificate: null
};

export function certificateReducer(state = initialState, action: CertificateActions.CertificateActions) {
  switch (action.type) {
    case CertificateActions.SET_CERTIFICATE:
      return {
        ...state,
        certificate: action.payload
      };
  }
  return state;
}
